import React from 'react'

import { arrayOf, number, shape, string } from 'prop-types'

import CTABanner from 'Pods/Shared/AiLanding/CTABanner/CTABanner'
import FAQs from 'Pods/Shared/AiLanding/FAQs/FAQs'
import SignInModalHost from 'Pods/Shared/AiLanding/SignInModalHost/SignInModalHost'

import { EMPTY_OBJECT } from 'Utils/stableDefaults'

import Hero from './Components/Hero/Hero'
import HowItWorks from './Components/HowItWorks/HowItWorks'

const HERO_SHAPE = shape({
  title: string,
  paragraphs: arrayOf(string),
  imageSrc: string,
  imageAlt: string,
  imageWidth: number,
  imageHeight: number,
  ctaLabel: string,
})

const HOW_IT_WORKS_SHAPE = shape({
  title: string,
  paragraphs: arrayOf(string),
  steps: arrayOf(string),
})

const FAQ_SHAPE = shape({
  title: string,
  items: arrayOf(shape({ question: string.isRequired, answer: string.isRequired })),
})

const CTA_BANNER_SHAPE = shape({
  title: string,
  subtitle: string,
})

// Content-agnostic template for the per-object AI generator SEO landings
// (/ai-3d-model-generator/car, ...). Every string arrives already resolved from Rails
// (see react_props_ai_generator_landing -> AiGeneratorPages::BuildPageContent), so the
// same tree will serve the AI image generator pages without a JS change.
//
// This is a cacheable fast page, but unlike AiSubLanding no section here gates its
// existence on window.pageConfig -- the copy is all SSR props, so hydration rebuilds an
// identical tree and nothing pops in. Only the CTA href/label refine in place once
// /load-services.js resolves. Keep it that way (see CLAUDE.md "SSR-stable rendering").
function AiGeneratorLanding({
  locale = 'en',
  hero = EMPTY_OBJECT,
  howItWorks = EMPTY_OBJECT,
  faq = EMPTY_OBJECT,
  ctaBanner = EMPTY_OBJECT,
  subscriptionPaymentFormUrl = '',
}) {
  return (
    <div className="ai-generator-landing">
      <Hero
        title={hero.title}
        paragraphs={hero.paragraphs}
        imageSrc={hero.imageSrc}
        imageAlt={hero.imageAlt}
        imageWidth={hero.imageWidth}
        imageHeight={hero.imageHeight}
        ctaLabel={hero.ctaLabel}
        subscriptionPaymentFormUrl={subscriptionPaymentFormUrl}
      />
      <HowItWorks
        title={howItWorks.title}
        paragraphs={howItWorks.paragraphs}
        steps={howItWorks.steps}
      />
      <FAQs title={faq.title} items={faq.items} idPrefix="ai-generator-landing-faq" />
      {ctaBanner.title && (
        <CTABanner
          title={ctaBanner.title}
          subtitle={ctaBanner.subtitle}
          subscriptionPaymentFormUrl={subscriptionPaymentFormUrl}
        />
      )}
      <SignInModalHost locale={locale} />
    </div>
  )
}

AiGeneratorLanding.propTypes = {
  locale: string,
  hero: HERO_SHAPE,
  howItWorks: HOW_IT_WORKS_SHAPE,
  faq: FAQ_SHAPE,
  ctaBanner: CTA_BANNER_SHAPE,
  subscriptionPaymentFormUrl: string,
}

export default AiGeneratorLanding
